module.exports = __webpack_public_path__ + "static/media/1992-Impreza-GC.0d605696.webp";